import type { DefectSuggestionItemProps } from "./DefectSuggestionItem.type";

import { Typography, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import "./DefectSuggestionItem.style.less";

const { Text } = Typography;

const DefectSuggestionItem = ({
  slug,
  confidence,
  name = "",
  onChange,
}: DefectSuggestionItemProps) => {
  const { t } = useTranslation();
  return (
    <span
      className="defect-suggestion-item"
      onClick={() => {
        onChange(slug);
      }}
      data-testid={slug}
    >
      <Tooltip
        placement="top"
        title={
          confidence
            ? `${Number((confidence * 100).toFixed(1))}% ${t(
                "form:staticField.defectSuggestion.confidence"
              )}`
            : undefined
        }
      >
        <Text underline>{name}</Text>
      </Tooltip>
    </span>
  );
};

export default DefectSuggestionItem;
